import { Map, List } from 'immutable';

import { groupAvailByRoom, getAvailStore } from './availUtils';
import { checkAvailSegments } from '../../utils';

import {ParamsContext} from '@synergycms_core/utils/paramsParser';
import actions from '@synergycms_app/store/actions';
import { getLoyaltyTier } from '../customer/loyaltyUtils';

export default {
  RESET_AVAIL: () => {
    return (dispatch, getState) => {
      const store = getState();
      return store.getIn(['customer', 'current_hotel']);
    };
  },
  GET_ASYNC: (flexible = false, hotelIds = []) => {
    return (dispatch, getState) => {
      const params = getState().getIn(["customer","params","params"]);
      const managerParams = new ParamsContext(
        params,
        "standar",
        (hotId, queryParams, prefix) => {
          dispatch(actions.hotels.setLastQueryParams(hotId, queryParams, prefix))
        });
      return dispatch(getAvailStore(managerParams, false, hotelIds)).then((res)=>{
        return res;
      });
    };
  },
  GET_FLEXIBLE_ASYNC: () => (dispatch, getState) => {
    const params = getState().getIn(["customer","params", "params"]);
    const managerParams = new ParamsContext(
        params,
        "standar");

    return dispatch(getAvailStore(managerParams, true)).then((res) => {
      return res;
    });
  },
  GET_LOYALTY_FLEXIBLE_ASYNC: () => (dispatch, getState) => {
    const params = getState().getIn(["customer","params", "params"]);
    const managerParams = new ParamsContext(
      params,
      "loyalty");

    return dispatch(getAvailStore(managerParams, true)).then((res) => {
      return res;
    });
  },
  GET_AVAIL_ASYNC: (group = false, forcedRate ) => {
    return (dispatch, getState) => {
      const rate = forcedRate ? forcedRate : getState().getIn(['customer','rate_selected']);
      const activeLoyalty = group ? getState().getIn(['customer', 'loyalty', 'descriptives', group, 'loyalty'], null) : getState().getIn(["customer","loyalty", "data", "loyalty"]);
      let params = getState().getIn(["customer","params","params"]);

      if(activeLoyalty?.size) {
        const loyaltyTier = getLoyaltyTier(getState())
        params = params.set("loyalty", loyaltyTier);
      }
      
      // IS LOYALTY
      if(activeLoyalty?.size && rate === 'loyalty') {
        const managerParams = new ParamsContext(params, "loyalty",(hotId, params, prefix) => dispatch(actions.hotels.setLastQueryParams(hotId, params, prefix)));

        return dispatch(getAvailStore(managerParams, false)).then((res) => {
          const hotelId = getState().getIn(['customer', 'current_hotel']);
          return {
            payload: res,
            standard: dispatch(actions.hotels.setLastQueryParams(hotelId, new ParamsContext(getState().getIn(["customer","params", "params"]),"standar"))),
            rate: dispatch(actions.customer.rateSelected.set('loyalty'))
          }
        });
      }

      // IS STANDARD
      const managerParams = new ParamsContext(params, "standar",(hotId, queryParams, prefix) => dispatch(actions.hotels.setLastQueryParams(hotId, queryParams, prefix)));
      return dispatch(getAvailStore(managerParams, false)).then((res)=>{
        return {payload: res,rate: dispatch(actions.customer.rateSelected.set('standard'))};
      });
    };
  },
  GET_LOYALTY_AVAIL_ASYNC: (group = false, hotelIds = []) => {
    return (dispatch, getState) => {
      const store = getState();
      let activeLoyalty = false;
      let loyaltyTier;
      let params = getState().getIn(["customer","params", "params"]);
      if(group) {
        activeLoyalty = store.getIn(['customer', 'loyalty', 'descriptives', group, 'loyalty'], null);
        loyaltyTier = store.getIn(['customer', 'loyalty','user','tier', 'current'], activeLoyalty?.getIn(['tier']));
      }else {
        activeLoyalty = store.getIn(["customer","loyalty", "data", "loyalty"]);
        loyaltyTier = store.getIn(['customer', 'loyalty','user','tier', 'current'], store.getIn(['customer', 'loyalty', 'data', 'loyalty', 'tier']));
      }

      //FALTA AGREGAR EL TIER ALS PARAMETRES
      params = params.set("loyalty", loyaltyTier);

      if(activeLoyalty?.size) {
        var managerParams = new ParamsContext(
          params,
          "loyalty",
          (hotId, params, prefix) => dispatch(actions.hotels.setLastQueryParams(hotId, params, prefix)));

        return dispatch(getAvailStore(managerParams, false, hotelIds)).then((res) => {
          return res;
        });
      }
      return Promise.resolve();
    };
  },
  GET_AVAIL_PARSED: () => {
    return (dispatch, getState) => {
      const store = getState();
      const avail = store.get('avail');


      return (
        avail &&
        avail.reduce((parsedAvail, hotelAvail, hotelId) => {
          // STANDARD
          const standardHotelQueryParams = store.getIn(['hotels', hotelId, 'params', 'string_query_params']);
          const standardBaseHotelQueryParams = store.getIn(['hotels', hotelId, 'params', 'base_string_query_params']);
          const standardServiceQueryParams = store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']);
          
          const standardRawHotelAvailResponse = hotelAvail.getIn([standardHotelQueryParams, 'raw_response']);
          const standardRawHotelAvailFlexibleResponse = hotelAvail.getIn([standardBaseHotelQueryParams, 'flexible_raw_response'], false);
          const standardStoreKey = [hotelId, standardHotelQueryParams, 'response'];
          const standardHotelServicesAvailResponse = store.getIn(['availServices', hotelId, standardServiceQueryParams, 'response']);
          const promotionCode = store.getIn(['customer','params', 'url_params', 'promotion_code'],false);
          const roomsCustomOrder = store.getIn(['hotels', hotelId, 'rooms_order'], List()).sortBy(b => b.get('weight'));

          if (
            (standardRawHotelAvailResponse && checkAvailSegments(standardRawHotelAvailResponse)) || 
            (standardRawHotelAvailFlexibleResponse && checkAvailSegments(standardRawHotelAvailFlexibleResponse))
          ) {
            parsedAvail = 
              parsedAvail.setIn(
                standardStoreKey, 
                groupAvailByRoom(
                  standardRawHotelAvailResponse, 
                  standardHotelServicesAvailResponse, 
                  roomsCustomOrder, 
                  (checkAvailSegments(standardRawHotelAvailFlexibleResponse, true) ? standardRawHotelAvailFlexibleResponse : false), 
                  promotionCode
                )
              );
            if(!checkAvailSegments(standardRawHotelAvailResponse) && checkAvailSegments(standardRawHotelAvailFlexibleResponse, true)) {
              parsedAvail = parsedAvail.setIn([hotelId, standardHotelQueryParams, 'is_alter_search'],false);
            }
          } else {
            parsedAvail = parsedAvail.setIn(standardStoreKey, Map({ success: false }));
          }
          
          
          //LOYALTY
          const loyaltyHotelQueryParams = store.getIn(['hotels', hotelId, 'params', 'string_loyalty_query_params']);
          const loyaltyBaseHotelQueryParams = store.getIn(['hotels', hotelId, 'params', 'base_string_loyalty_query_params']);
          const loyaltyServiceQueryParams = store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']);
          
          const loyaltyRawHotelAvailResponse = hotelAvail.getIn([loyaltyHotelQueryParams, 'raw_response']);
          const loyaltyRawHotelAvailFlexibleResponse = hotelAvail.getIn([loyaltyBaseHotelQueryParams, 'flexible_raw_response'], false);
          
          const loyaltyStoreKey = [hotelId, loyaltyHotelQueryParams, 'response'];
          const loyaltyHotelServicesAvailResponse = store.getIn(['availServices', hotelId, loyaltyServiceQueryParams, 'response']);

          if (
            (loyaltyRawHotelAvailResponse && checkAvailSegments(loyaltyRawHotelAvailResponse)) ||
            (loyaltyRawHotelAvailFlexibleResponse && checkAvailSegments(loyaltyRawHotelAvailFlexibleResponse,true))
          ) {
            parsedAvail = 
              parsedAvail.setIn(
                loyaltyStoreKey, 
                groupAvailByRoom(
                  loyaltyRawHotelAvailResponse,
                  loyaltyHotelServicesAvailResponse, 
                  roomsCustomOrder,
                  checkAvailSegments(loyaltyRawHotelAvailFlexibleResponse, true) ? loyaltyRawHotelAvailFlexibleResponse : false,
                  promotionCode
                )
              );
            if(!checkAvailSegments(loyaltyRawHotelAvailResponse) && checkAvailSegments(loyaltyRawHotelAvailFlexibleResponse, true)) {
              parsedAvail = parsedAvail.setIn([hotelId, loyaltyHotelQueryParams, 'is_alter_search'],false);
            }
          } else {
            parsedAvail = parsedAvail.setIn(loyaltyStoreKey, Map({ success: false }));
          }
          
          return parsedAvail;
          
        }, new Map())
      );
    }
  },
  GET_PARSED_AVAIL: () => {
    return (dispatch, getState) => {
      const store = getState(),
        avail = store.get('avail');

      return (
        avail &&
        avail.reduce((parsedAvail, hotelAvail, hotelId) => {
          const hotelQueryParams = store.getIn(['hotels', hotelId, 'params', 'string_query_params']);
          const baseHotelQueryParams = store.getIn(['hotels', hotelId, 'params', 'base_string_query_params']);
          const serviceQueryParams = store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']);
          const rawHotelAvailResponse = hotelAvail.getIn([hotelQueryParams, 'raw_response']);
          const rawHotelAvailFlexibleResponse = hotelAvail.getIn([baseHotelQueryParams, 'flexible_raw_response'], false);
          const storeKey = [hotelId, hotelQueryParams, 'response'];
          const hotelServicesAvailResponse = store.getIn(['availServices', hotelId, serviceQueryParams, 'response']);
          const promotionCode = store.getIn(['customer','params', 'url_params', 'promotion_code'],false);
          const roomsCustomOrder = store.getIn(['hotels', hotelId, 'rooms_order'], List()).sortBy(b => b.get('weight'));

          if ((rawHotelAvailResponse && checkAvailSegments(rawHotelAvailResponse)) || (rawHotelAvailFlexibleResponse && checkAvailSegments(rawHotelAvailFlexibleResponse))) {
            return parsedAvail.setIn(storeKey, groupAvailByRoom(rawHotelAvailResponse, hotelServicesAvailResponse, roomsCustomOrder, (checkAvailSegments(rawHotelAvailFlexibleResponse, true) ? rawHotelAvailFlexibleResponse : false), promotionCode));
          } else {
            return parsedAvail.setIn(storeKey, Map({ success: false }));
          }
        }, new Map())
      );
    };
  },
  GET_LOYALTY_PARSED_AVAIL: () => {
    return (dispatch, getState) => {
      const store = getState();
      const avail = store.get('avail');
      return (
        avail &&
        avail.reduce((parsedAvail, hotelAvail, hotelId) => {
          const hotelQueryParams = store.getIn(['hotels', hotelId, 'params', 'string_loyalty_query_params']);
          const serviceQueryParams = store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']);
          const rawHotelAvailResponse = hotelAvail.getIn([hotelQueryParams, 'raw_response']);
          const storeKey = [hotelId, hotelQueryParams, 'response'];
          const hotelServicesAvailResponse = store.getIn(['availServices', hotelId, serviceQueryParams, 'response']);
          const promotionCode = store.getIn(['customer','params', 'url_params', 'promotion_code'],false);
          const roomsCustomOrder = store.getIn(['hotels', hotelId, 'rooms_order'], List()).sortBy(b => b.get('weight'));

          if ((rawHotelAvailResponse && checkAvailSegments(rawHotelAvailResponse))) {
            return parsedAvail.setIn(storeKey, groupAvailByRoom(rawHotelAvailResponse, hotelServicesAvailResponse, roomsCustomOrder, false, promotionCode));
          } else {
            return parsedAvail.setIn(storeKey, Map({ success: false }));
          }
        }, new Map())
      );
    };
  },
  SET_RELATED_AVAIL: () => {
    return (dispatch, getState) => {
      const store = getState();
      const webType = store.getIn(['customer', 'web_type'], false);
      if(webType !== "PORTAL") return;

      const hotelId = store.getIn(['customer', 'current_hotel']);
      const roomsAvail = store.getIn([
        'avail',
        hotelId,
        store.getIn(['hotels', hotelId, 'params', 'string_query_params']),
        'response'
      ]);
      const loyaltyRoomsAvail = store.getIn([
        'avail',
        hotelId,
        store.getIn(['hotels', hotelId, 'params', 'string_loyalty_query_params']),
        'response',
      ]);

      if (roomsAvail.get('success') !== false || loyaltyRoomsAvail.get('success') !== false) return;


      const params = store.getIn(['customer', 'params', 'params'], undefined);
      const group = store.get("group", false)
      const city =
        webType !== 'WI' &&
        params &&
        params.get('city_id') &&
        store.getIn(['hotels', 'hotels_info', 'cities']).find(city => {
          return city.get('id') === parseInt(params.get('city_id'), 10);
        });
      if(!city) return;

      let cityId = city.get('id');
      var hotelIds = store.getIn(['hotels'])
        .getIn(['hotels_info', 'hotels'])
        .filter(h => h.get('city_id') === cityId)
        .toJS()
        .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());

      return Promise.all([
        dispatch(actions.hotels.setRelatedHotels()),
        dispatch(actions.hotels.getAsync(hotelIds))
        .then(() => {
          Promise.all([
            dispatch(actions.customer.loyalty.getDescriptiveAsync(group))
            .then((result) => {
              return result.get(group, null) ? dispatch(actions.avail.getLoyaltyAvailAsync(group, hotelIds)) : dispatch(actions.avail.getAsync());
            })
          ]);
        })
      ]);
    }
  },
  CLEAR: () => {
  },

};
